// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig } from '@hey-api/client-fetch';

export const client = createClient(createConfig());